module.exports = __webpack_public_path__ + "assets/img/jkz.199de130.svg";